
import React, { useEffect } from 'react';
import { useContext } from "react";
import { Box, Typography, Grid,Paper,Button,Step,StepLabel,Stepper,CircularProgress } from "@mui/material";
import { createTheme, useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery';
import useStyles from '../theme/formCssStyles';
import Promotion from './Promotion';
import { ThemeProvider } from '@mui/styles';
import { useHistory } from "react-router-dom";
import { useAuth } from '../context/authContext';

import { errorContext } from '../Components/ErrorDisplay'

const steps = [ 'Promotions'];

const theme = createTheme({
    overrides: {
    
     MuiStepIcon: {
      root: {
        '&$completed': {
          color: 'pink',
        },
        '&$active': {
          color: 'maroon',
        },
      },
      active: {},
      completed: {},
    },
   
  
  
    MuiStepLabel:{
        root:{
            color:'blue'
            // '&$active': {
            //     color: 'red',
            //   },  
        },
        active:{ '&$active': {
            color: 'maroon',
          },
        },
        },
    },    }
);
function ManagePromotions( ) 
{
    const classes = useStyles();
    const muiTheme = useTheme();
    const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
    let history = useHistory();
    const { user } = useAuth();
    const {loading,setErrorMessage} = useContext(errorContext);
    const [activeStep, setActiveStep] = React.useState(0);
    const [formShown,setFormShown] = React.useState(false);
    const [selectedRow,setSelectedRow] = React.useState(null);
    const [selectedPartner,setSelectedPartner] = React.useState(null);
    const [selectedBrand,setSelectedBrand] = React.useState(null);
    const [selectedPromotion,setSelectedPromotion] = React.useState(null);
    //const [errorMessage1,setErrorMessage1] = React.useState(null);
    //const [loading1,setLoading1] = React.useState(false);
    
    useEffect(()=>{
        setErrorMessage(null);
    }   ,[]);
    function handleNext() {
        setErrorMessage(null);
        console.log("handleNext"+JSON.stringify(selectedRow));
        switch(activeStep)
        {
            case 0:
                history.push("/");
                break;
            default:
                break;
        }

        setActiveStep(prevActiveStep => prevActiveStep + 1);
    
        if (activeStep === steps.length - 1)
            console.log('next');
      }
      React.useEffect(()=>{
        //alert("selected row:"+JSON.stringify(selectedRow))
       // setErrorMessage(null);
      })
      function handleBack() {
        setErrorMessage(null);
        switch(activeStep)
        {
            case 0:
                setSelectedPromotion(null);
                break;
            default:
                break;
        }

        setActiveStep(prevActiveStep => prevActiveStep - 1);
      }
    
      function handleReset() {
        setErrorMessage(null);
        setActiveStep(0);
        setSelectedPartner(null);
        setSelectedBrand(null);
        setSelectedPromotion(null);
      }
      function handleSetSelectedRow(row)
      {
        setSelectedRow(row);
        switch(activeStep)
        {
            case 0:
                {
                    setSelectedPromotion(row);
                    break;
                }
            default:
                break;
        }
            
        
      }
      function getSelectedNames()
      {
        var displayStr = "";
        /* if(selectedPartner !== null)
            displayStr += "Selected Partner : "+selectedPartner.name; 
        if(selectedBrand !== null)
            displayStr += " / Selected Brand : "+selectedBrand.name;*/
        if(selectedPromotion !== null)
            displayStr += "Selected Promotion : "+selectedPromotion.name;
        return displayStr;
      }
      function getStepContent(step) {
        switch (step) {
          // case 0:
          //   return <DisplayUnitDetailsForCBForm />;
             /* case 0:
                return (
                <Partner
                setSelectedRow={handleSetSelectedRow}
                setFormShown={setFormShown}
                alreadySelectedOwnRow={selectedPartner}
         
                />
                ); 
            case 0:
                return(
                    <Brand 
                    IssuingPartnerRow={selectedPartner}
                    setSelectedRow={handleSetSelectedRow}
                    setFormShown={setFormShown}
                    alreadySelectedOwnRow={selectedBrand}
         
                    />
                );*/
            case 0:
                return(
                    <Promotion
                    BrandRow={selectedBrand}
                    setSelectedRow={handleSetSelectedRow}
                    setFormShown={setFormShown}
                    alreadySelectedOwnRow={selectedPromotion}
         
                    />
                );
         
            default:
                return "Unknown step";
            }
        }    
    
      
    return(
         <Box sx={{borderStyle:'none',borderColor:'green' }} style={{ paddingLeft: isMobile ? 8 : 0, paddingRight: isMobile ? 8 : 0 }}>
            <Typography
                variant="h5"
                style={{color:'black', textAlign:'left', marginBottom: 12, wordBreak: 'break-word'}}
            >
                Promotions
            </Typography>
             {/* <Toolbar> */}
        <Grid container xs={12} direction="column">
            {steps.length > 1 && (
            <Grid item xs={12} style={{borderColor:'red',borderStyle:'none'}}>
                <ThemeProvider theme={theme}>
                    <Stepper
                        activeStep={activeStep}
                        orientation={isMobile ? 'vertical' : 'horizontal'}
                        style={{
                            minHeight: isMobile ? 'auto' : '30px',
                            justifyContent:'flex-start',
                            width: isMobile ? '100%' : '35%',
                            overflowX: isMobile ? 'visible' : 'auto'
                        }}
                        className={classes.stepper}>
                        {steps.map(label => (
                            <Step key={label}
                            
                            >
                            
                            <StepLabel sx={{
                                textAlign: 'left',
                                
                                "& .MuiStepLabel-horizontal  .Mui-active": {
                                color: "red",
                                }
                            }} >{label}</StepLabel>
                            </Step>
                        ))}

                    </Stepper>
                </ThemeProvider>
            </Grid>
            )}
                        <Grid item xs={12} style={{borderColor:'black',borderStyle:'none',textAlign:'left'}}>
                                    <Box style={{display:'flex',justifyContent:'flex-start',alignItems:'center',zIndex:1001}}>
                    { loading && <CircularProgress variant='indeterminate' />}
                  </Box>
                  
                  </Grid>

          
            <Grid
                item
                container
                direction="row"
                xs={12}
                spacing={1}
                style={{ borderStyle: 'none', borderColor: 'blue', marginTop: isMobile ? 8 : 0 }}
            >
                <Grid item container xs={12} direction="column">
                    {activeStep === steps.length ? (
                        <Grid item>
                            <Typography className={classes.instructions}>
                                All steps completed - you&apos;re finished
                            </Typography>
                            
                        </Grid>
                    ) : (
                        // <div>  {getStepContent(activeStep)}</div>
                        <Grid item container xs={12} style={{
                            borderStyle: 'none',
                            borderColor: 'green',
                            minHeight: isMobile ? 'auto' : '300px'
                            }} direction="column" >
                            
                          
                                {getStepContent(activeStep)}
                          
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </Grid>
    </Box>
    );
}

export default ManagePromotions;
